import { lazy } from 'react'

import VenueOnboardingLoader from './loader'

export default {
  VenueOnboarding: {
    Component: lazy(() => import('./VenueOnboarding.Page')),
    Loader: VenueOnboardingLoader,
  },
}
